import React, { useEffect, useState } from 'react';
import CitaForm from './AdministrarCitas';
import SidebarCitas from './SidebarCitas';

const AgendarVisitaPage = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sideBarVsisible, setSideBarVisible] = useState(false);

    useEffect(() => {
        // Cerrar el sidebar al montar el componente
        setSideBarVisible(true);
    }, []);

    return (
        <div style={{ position: 'relative', minHeight: 'calc(100vh - 60px)' }}> {/* altura ajustable */}
            {/* Sidebar */}

            {sideBarVsisible && <SidebarCitas isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />}

            {/* Contenido principal */}
            <div style={{ padding: '1rem' }}>
                <CitaForm />
            </div>
        </div>
    );
};

export default AgendarVisitaPage;